module.exports = __webpack_public_path__ + "static/media/reallypoor.03a0f85c.svg";